import React, { Component } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";
import { Alert } from "react-bootstrap";
import Auth from "../Auth";
import LoginForm from "../forms/LoginForm";
import Loading from "./Loading";
import taskmanagerLogo from "../images/TaskManagerLogo_2c_cmyk-04-01.png";

const ErrorMessage = () => (
  <Alert bsStyle="danger" className="login-message">
    Invalid username or password
  </Alert>
);

class Login extends Component {
  state = {
    loginInProgress: false,
    shouldRedirect: false,
    error: false
  };

  redirectPath = () => {
    const locationState = this.props.location.state;
    const pathname =
      locationState && locationState.from && locationState.from.pathname;
    return pathname || "/";
  };

  handleSubmit = values => {
    const { username, password } = values;
    this.setState({ loginInProgress: true, error: false });

    Auth.login(username, password)
      .then(() => this.setState({ shouldRedirect: true }))
      .catch(() =>
        this.setState({
          loginInProgress: false,
          shouldRedirect: false,
          error: true
        })
      );
  };

  render() {
    if (this.state.shouldRedirect) {
      return <Redirect to={this.redirectPath()} />;
    }

    return (
      <div className="login-container">
        <div className="flex-center">
          <div className="login-wide">
            <img
              src={taskmanagerLogo}
              alt="Task Manager Logo"
              style={{ width: 380, height: 68 }}
            />
            {this.state.error ? <ErrorMessage /> : ""}
            {this.state.loginInProgress ? (
              <div>
                <Loading />
              </div>
            ) : (
              <LoginForm onSubmit={this.handleSubmit} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
Login.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.object
  }).isRequired
};

export default Login;



// WEBPACK FOOTER //
// ./src/components/Login.js